"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var ComponentBase =
/** @class */
function (_super) {
  __extends(ComponentBase, _super);

  function ComponentBase() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Object.defineProperty(ComponentBase.prototype, "parentComponentKey", {
    get: function get() {
      return undefined;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ComponentBase.prototype, "configuration", {
    get: function get() {
      var configuration = this.props.configuration;

      if (configuration) {
        var category = configuration[this.categoryKey];
        var parentComponentKey = this.parentComponentKey;

        if (parentComponentKey) {
          var parentConfiguration = category && category[parentComponentKey];

          if (parentConfiguration && parentConfiguration.childComponents) {
            return parentConfiguration.childComponents[this.componentKey];
          }
        } else {
          return category && category[this.componentKey];
        }
      }

      return;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ComponentBase.prototype, "globalConfiguration", {
    get: function get() {
      var configuration = this.props.configuration;

      if (configuration) {
        return configuration.global;
      }
    },
    enumerable: true,
    configurable: true
  });
  return ComponentBase;
}(react_1.Component);

exports.ComponentBase = ComponentBase;